import { createContentHook } from './createContentHook';
import type { FooterContent } from '../types/FooterContent';

export const useFooterContent = createContentHook<FooterContent>('/Footer');
